<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-width="95px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车场名称:" prop="spaceName">
            <el-input disabled v-model="value.spaceName" placeholder="请选择车场" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆身份" prop="carManageType">
            <el-select
              v-model="value.carManageType"
              style="width: 100%"
              placeholder="请选择车辆身份"
              disabled
            >
              <el-option
                v-for="item in carManageTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号:" prop="plateNumber">
            <el-input
              disabled
              v-model="value.plateNumber"
              placeholder="请输入车牌号"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户姓名:" prop="personName">
            <el-input
              disabled
              v-model="value.personName"
              placeholder="请输入客户姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户手机:" prop="personPhone">
            <el-input
              disabled
              v-model="value.personPhone"
              placeholder="请输入客户手机"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁起期:" prop="effectTime" v-if="value.carManageType==1">
            <el-date-picker
              v-model="value.effectTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              align="right"
              type="date"
              placeholder="选择租赁起期"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁止期:" prop="expiredTime" v-if="value.carManageType==1">
            <el-date-picker
              v-model="value.expiredTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              align="right"
              type="date"
              placeholder="选择租赁止期"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-if="value.carManageType == 1 && value.isMainCar == 1">
          <el-form-item label="退款金额" prop="refundAmount">
            <el-input
              v-model="value.refundAmount"
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退款后止期:" prop="newEndTime" v-if="value.carManageType == 1 && value.isMainCar == 1">
            <el-date-picker
              v-model="value.newEndTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              align="right"
              type="date"
              placeholder="选择退款后止期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="退款备注:" prop="description">
            <el-input
              clearable
              v-model="value.description"
              type="textarea"
              :rows="4"
              placeholder="请输入备注"
              show-word-limit
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
              >退款
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancelRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  carManageRefund,
} from './parkvehicle';
import { getSpaceList} from '@/api/v4ward/carv2/carmonthquickRegistration';
import { getDictionary } from '@/api/common.js';
export default {
  components: {

  },
  props: ['value'],
  data() {
    return {
      showCarOwnerFlag: false,
      showCarCodeFlag: false,
      regionList: [],
      carManageTypeList: [],
      carManageType: '',
      statusList: [], //月卡车状态
      spaceList: [], //车场
      formRules: {
        spaceName: [{ required: true, message: '车场名称不能为空', trigger: 'blur' }],
        carManageType: [{ required: true, message: '车辆身份不能为空', trigger: 'blur' }],
        plateNumber: [{ required: true, message: '车牌号不能为空', trigger: 'blur' }],
        personName: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        personPhone: [
          { required: true, message: '客户手机不能为空', trigger: 'blur' },
          { required: true, pattern: this.$validation.phone, message: '请输入正确的手机号', trigger: 'change', }
        ],
        effectTime: [{ required: true, message: '租赁起期不能为空', trigger: 'blur' }],
        expiredTime: [{ required: true, message: '租赁止期不能为空', trigger: 'blur' }],
        newEndTime: [{ required: true, message: '退款后止期不能为空', trigger: 'blur' }],
        refundAmount: [{ required: true, message: '退款金额不能为空', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.value.bigOrSmallCar += '';
    this.value.isMainCar += '';
    this.value.feeRuleId += '';
    this.value.carStatus += '';
    this.value.cycleNum += '';
    this.value.carManageType += '';
    this.initData();
  },
  methods: {
    initData() {
      this.getSpaceList();
      this.getCarManageTypeList();

    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },

    getCarManageTypeList(){
      getDictionary('car_manage_type').then((res) => {
        this.carManageTypeList = res.data;
        console.log('this.carManageTypeList', this.carManageTypeList)
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.value.isNormalUpdate = 1;
          carManageRefund(this.value).then((res) => {
            this.$message.success('修改成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelRecord() {
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancel');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
